import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { accountingApi } from '../../services/accountingApi';
import CatalogCrud from '../../components/accounting/CatalogCrud';
import AccountingRucCompanies from '../../components/accounting/AccountingRucCompanies';
import '../../styles/accounting.css';

export default function AccountingConfig() {
    const [meta, setMeta] = useState({});

    const load = async () => setMeta(await accountingApi.meta());

    useEffect(() => {
        load();
    }, []);

    const catalogs = [
        'banks',
        'rucBanks',
        'suppliers',
        'areas',
        'categories',
        'externalRequesters',
        'paymentMethods',
        'receiptTypes',
    ];

    return (
        <div>
            <Header namePage="accountingConfigPage" />

            <section className="sectionBody sectionBodyAccounting">
                <div className="containerBody">
                    <main className="accountingPage">
                        <header className="accHero">
                            <div>
                                <span>MovilesPay</span>
                                <h1>Configuración contable</h1>
                                <p>
                                    Administra empresas, credenciales SUNAT, bancos, proveedores, áreas,
                                    categorías, solicitantes, métodos de pago y comprobantes.
                                </p>
                            </div>
                        </header>

                        {meta.permissions?.canEdit === false && (
                            <div className="accNotice">
                                Tu rol puede crear registros, pero no puede editar ni eliminar catálogos contables.
                            </div>
                        )}

                        <AccountingRucCompanies meta={meta} reload={load} />

                        <div className="catalogGrid">
                            {catalogs.map((type) => (
                                <CatalogCrud key={type} type={type} meta={meta} reload={load} />
                            ))}
                        </div>
                    </main>
                </div>
            </section>

            <Footer />
        </div>
    );
}
